import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    site_name: 'SimpleQuote.Org',
    globalMetaData: {
      faviconPath: '/favicons/simplequote.org/favicon.ico',
      faviconFileType: 'image/x-icon',
    },
  },
  mutations: {
    initialiseStore(state) {
      // Check if the ID exists
      if (sessionStorage.getItem('sq_store')) {
        // Replace the state object with the stored item
        this.replaceState(
          Object.assign(state, JSON.parse(sessionStorage.getItem('sq_store'))),
        );
      }
    },
  },
  actions: {
  },
  modules: {
  },
});

// Subscribe to store updates
store.subscribe((mutation, state) => {
  // Store the state object as a JSON string
  sessionStorage.setItem('sq_store', JSON.stringify(state));
});

export default store;
